import type { CorridorType, LocationType } from '@/entities/dashboard/mapping';

import { MAP_LAYER_IDS, MAP_REPORTS, type MapLayerId, type MapReport } from '../model/types';
import { MAP_LAYERS } from './map-layers.config';

const isLayerId = (value: string): value is MapLayerId => (MAP_LAYER_IDS as readonly string[]).includes(value);

/** Reads the URL's layer list, dropping anything that is not a known layer id. */
export function parseMapLayers(raw: string): MapLayerId[] {
  const active = new Set(raw.split(',').filter(isLayerId));

  return MAP_LAYER_IDS.filter((id) => active.has(id));
}

/** Keeps the canonical order so toggling never reshuffles the URL. */
export function toggleMapLayer(active: MapLayerId[], id: MapLayerId): MapLayerId[] {
  const next = new Set(active);
  if (!next.delete(id)) next.add(id);

  return MAP_LAYER_IDS.filter((layerId) => next.has(layerId));
}

export function enabledReports(active: MapLayerId[]): MapReport[] {
  const reports = new Set(active.flatMap((id) => MAP_LAYERS[id].reports));

  return MAP_REPORTS.filter((report) => reports.has(report));
}

export function enabledCorridorTypes(active: MapLayerId[]): CorridorType[] {
  return active.map((id) => MAP_LAYERS[id].corridorType).filter((type): type is CorridorType => type !== undefined);
}

export function visibleLocationTypes(active: MapLayerId[]): LocationType[] {
  return active.flatMap((id) => MAP_LAYERS[id].locationTypes ?? []);
}
